import { LOCALE } from '@foxrenderfarm/internals'

export const showNewsList = [LOCALE.EN, LOCALE.KR, LOCALE.JP]
